export const patientModalAction = {
  toggleModal: (state, action) => {
    const { type, value } = action.payload;

    state[type] = value;
  },
};
